<div
  class="marker bg-white rounded-xl p-2 flex flex-col gap-2 min-w-full !border-[#B4BFCB] border border-solid z-999 relative"
  style="width: 24rem; transform: translateX(-50%) translateY(-120%)" [dir]="direction">
  <div class="flex justify-between items-center pl-3">
    <div class="flex gap-2 items-center h-[3.625rem]">
      <!-- <ng-icon name="station" class="!text-xl colored-icon" /> -->
      <div class="flex flex-col text-sm">
        <span class="text-sm">{{ stationName }}</span>
        <span class="font-normal text-sm text-[#5C748F]">{{ stationCodeText }}: {{ data.stop.stopcode }}</span>
        <span>
          @if (data.stop.streetName) {
            <span>{{data.stop.streetName}}</span>
          }
          @if (data.stop.streetNumber) {
            <span> {{data.stop.streetNumber}}</span>
          }
          @if (data.stop.streetName || data.stop.streetNumber) {
            <span>, </span>
          }
          @if (data.stop.cityName) {
            <span>{{data.stop.cityName}}</span>
          }
        </span>
      </div>
    </div>

    <ng-icon [name]="!!isFavoriteStation ? 'heart-filled' : 'heart'" class="!text-xl" />
  </div>

  <!-- Simple Rating Display - Self Contained -->
  @if (data.stop.rating) {
    <div class="flex gap-1 items-center">
      <!-- Stars using simple HTML/CSS -->
      <div class="flex items-center">
        @for (star of [1,2,3,4,5]; track star) {
          <span class="text-lg"
            [style.color]="star <= (data.stop.rating?.averageRating || 0) ? '#10B981' : '#D1D5DB'">
          {{ star <= (data.stop.rating?.averageRating || 0) ? '★' : '☆' }} </span>
        }
      </div>
      <!-- Rating text -->
      @if (data.stop.rating?.averageRating && data.stop.rating?.ratingsCount) {
        <span class="text-sm text-gray-700">
          ({{ data.stop.rating.ratingsCount }} {{ ratingsText }})
        </span>
      }
    </div>
  }

  <!-- Fallback if no rating data -->
  @if (!data.stop.rating) {
    <div class="flex gap-1 items-center">
      <div class="flex items-center">
        @for (star of [1,2,3,4,5]; track star) {
          <span class="text-lg text-gray-300">☆</span>
        }
      </div>
    </div>
  }

  <app-stations-result-list-item-lines [routes]="data.stop.routesInStop" />
  @if (showPickStationButton) {
    <mot-button
      buttonClass="choose-station !bg-primary !px-2 w-full !text-white !rounded-xl !align-middle"
      [text]="pickStationText" />
  }


  @if (shouldShowPickOriginDestinationButtons()) {
    <div class="flex flex-wrap gap-2">
      <mot-button buttonClass="choose-origin !bg-primary !px-2 flex-1 !text-white !rounded-xl !align-middle"
        [text]="originButtonTitle">
      </mot-button>
      <mot-button buttonClass="choose-destination !bg-primary !px-2 flex-1 !text-white !rounded-xl !align-middle"
        [text]="destinationButtonTitle">
      </mot-button>
      @if (data.showAddStopButton) {
        <mot-button
          buttonClass="choose-stop !bg-primary !px-2 flex-1 !text-white !rounded-xl !align-middle"
          [text]="addStopButtonTitle">
        </mot-button>
      }
    </div>
  }

  <button type="button" class="close-station-data !p-0 !w-2 !h-2 border-none bg-transparent absolute top-2"
  [ngClass]="direction === 'rtl' ? 'left-4' : 'right-4'" [attr.aria-label]="closeText">x</button>
</div>